<div class="panel_wrapper">
  <div class="assign-shift">
    <div class="d-flex  flex-wrap justify-content-between mb-3">
      <span class="assign_shift_date me-3">{{date | date: 'dd-MM-YYYY'}}</span>
      <span class="assign_shift_employee">{{employeeFirstName}} {{employeeLastName}}</span>
    </div>
    <div class="d-flex flex-row mb-2">
      <div class="shift_type_div" (click)="chooseShiftDayType(EmployeeLogTypes.Shift)">
        <div *ngIf="isShiftDayTypeSelected(EmployeeLogTypes.Shift)" class="shift_type_selection_selected"></div>
      </div>
      <span>
        <i *ngIf="errorModel!=null && errorModel['From']!=null"
           class="pi pi-exclamation-circle error_color float-end shifts-error"
           pTooltip="{{errorModel['From']|translate}}" tooltipPosition="top"></i>
        <span class="me-3 ms-2">{{'MANAGER_EMPLOYEES.FROM' | translate}}</span>
      <input type="number" class="shifts_overlay_input" min="0" max="24" [(ngModel)]="addOrEditEmployeeLogModel.from">
      </span>
      <span>
        <i *ngIf="errorModel!=null && errorModel['To']!=null"
           class="pi pi-exclamation-circle error_color float-end shifts-error"
           pTooltip="{{errorModel['To']|translate}}" tooltipPosition="top"></i>
        <span class="me-3 ms-3">{{'MANAGER_EMPLOYEES.TO' | translate}}</span>
      <input type="number" class="shifts_overlay_input" min="0" max="24" [(ngModel)]="addOrEditEmployeeLogModel.to">
      </span>
    </div>
    <div class="d-flex flex-row mb-2">
      <div class="shift_type_div" (click)="chooseShiftDayType(EmployeeLogTypes.FreeDay)">
        <div *ngIf="isShiftDayTypeSelected(EmployeeLogTypes.FreeDay)" class="shift_type_selection_selected"></div>
      </div>
      <span class="ms-2">{{'MANAGER_EMPLOYEES.FREE_DAY' | translate}}</span>
    </div>
    <div class="d-flex flex-row mb-2">
      <div class="shift_type_div" (click)="chooseShiftDayType(EmployeeLogTypes.SickLeave)">
        <div *ngIf="isShiftDayTypeSelected(EmployeeLogTypes.SickLeave)" class="shift_type_selection_selected"></div>
      </div>
      <span class="ms-2">{{'MANAGER_EMPLOYEES.SICK_DAY' | translate}}</span>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between pb-2">
    <button *ngIf="!editEnabled" [disabled]="disableBtn" class="btn_login w-100" (click)="addEmployeeLog()">{{ 'SAVE' | translate}}</button>
    <button *ngIf="editEnabled" [disabled]="disableBtn" class="btn_login w-100" (click)="updateEmployeeLog()">{{ 'SAVE' | translate}}</button>
  </div>
</div>
